const styles = {
  root: {
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '7.5px 12px',
    gap: 4,
    height: 32,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#F4F6F8',
    },
  },
  coursePage: {
    marginRight: 0,
  },
}

export default styles
